import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import "./SearchResult.css";
import truck from "../../../../../Image/truck.png";
import CO2 from "../../../../../Image/CO2.jpg";
import { Link } from "react-router-dom";
import RefreshOutlinedIcon from "@material-ui/icons/RefreshOutlined";

const useStyles = makeStyles({});

const SearchResult2 = () => {
  const data = "heelo";
  const classes = useStyles();
  return (
    <Container>
      <div className="searchResult">
        <Grid container spacing={4}>
          <Grid item xs={12} lg={4} md={4}>
            <Box className="searchMain">
              <Box className="searchLeftMain">
                <Avatar alt="truck" src={truck} />
                <Box>
                  <Typography variant="h5">Freezer</Typography>
                  <Typography variant="h6">FTL</Typography>
                </Box>
              </Box>
              <Box className="CO2">
                <img src={CO2} alt="" className="CO2_img" />
                <Typography variant="h5">50 g</Typography>
              </Box>
            </Box>
            <Box className="searchContent">
              <Box>
                <Box>
                  <Typography variant="h5">Dubai</Typography>
                </Box>
                <Box className="destinationMain2">
                  <Box className="circle"></Box>
                  <Box className="destinationLines"></Box>
                  <Box className="circle"></Box>
                </Box>
                <Box>
                  <Typography variant="h5">Saudi</Typography>
                </Box>
              </Box>
              <Box>
                <Box className="truckSmall">
                  <Avatar alt="truck" src={truck} />
                </Box>
              </Box>
              <Box className="searchRight">
                <Box>
                  <Typography variant="h5"> 30/09/2022</Typography>
                </Box>
                <Box>
                  <Typography variant="h5"> 18 Hours</Typography>
                  <Typography variant="h5"> 9:00 AM</Typography>
                </Box>
                <Box>
                  <Typography variant="h5">ETA</Typography>
                  <Typography variant="h5">31/09/2022</Typography>
                </Box>
              </Box>
            </Box>
            <Link to="/prodect-details">
              {" "}
              <button className="common-btn margin2">AED 90/ KM</button>
            </Link>
          </Grid>
          <Grid item xs={12} lg={8} md={8}>
            <Box>
              <Box className="reset_btn">
                <button>
                  <span>
                    <RefreshOutlinedIcon />
                  </span>{" "}
                  filter reset
                </button>
              </Box>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d326948.2109828979!2d54.92408675744101!3d25.125495167727223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sbd!4v1665478117118!5m2!1sen!2sbd"
                width="100%"
                height="545px"
                style={{ border: "0" }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default SearchResult2;
